import busIcon from "../../../icons/bus.svg";
import ebusIcon from "../../../icons/ebus.svg";
import trolleyIcon from "../../../icons/trolley.svg";
import tramIcon from "../../../icons/tram.svg";

const icons = {
    bus: busIcon,
    ebus: ebusIcon,
    trolley: trolleyIcon,
    tram: tramIcon,
}


export default ({type}) => {
    return icons[type] ?
        <img src={icons[type]} alt={""} style={{width: 24, height: 24, display: "inline-block"}}/> :
        <div style={{width: 24, height: 24, display: "inline-block"}}/>
}